(function () {
  /**
   * Sensory Immersion — Swiper initialization
   * Uses globally loaded Swiper v12 from theme.liquid
   *
   * Two swipers:
   *   1. Media slider (pictures + video) — centeredSlides, active slide enlarges
   *   2. Senses cards carousel — centered, one by one snapping
   */

  const INITIALIZATION_RETRIES = 40;
  const INITIALIZATION_INTERVAL_MS = 100;

  function getSwiperConstructor() {
    return window.Swiper;
  }

  /**
   * Media slider: active = 530px desktop / 250px mobile
   *               inactive = 250px desktop / 117px mobile
   * centeredSlides + loop for infinite feel
   */
  function initMediaSwiper(SwiperConstructor) {
    const el = document.querySelector('[data-media-swiper]');
    if (!el) return;

    /* Find initial slide index — first video block gets focus */
    const slides = el.querySelectorAll('.swiper-slide');
    let initialIndex = 0;
    slides.forEach(function (slide, i) {
      if (slide.querySelector('video')) {
        initialIndex = i;
      }
    });

    new SwiperConstructor(el, {
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: initialIndex,
      spaceBetween: 30,
      speed: 600,
      loop: true,
      loopAdditionalSlides: 2,
      grabCursor: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        0: {
          spaceBetween: 12,
        },
        769: {
          spaceBetween: 20,
        },
        1025: {
          spaceBetween: 30,
        },
      },
    });
  }

  /**
   * Senses cards carousel — centered on mobile, one by one snapping
   */
  function initSensesSwiper(SwiperConstructor) {
    const el = document.querySelector('[data-sensory-swiper]');
    if (!el) return;

    new SwiperConstructor(el, {
      slidesPerView: 'auto',
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesPerGroup: 1,
      spaceBetween: 20,
      speed: 550,
      watchOverflow: true,
      grabCursor: true,
      breakpoints: {
        0: {
          spaceBetween: 20,
          centeredSlides: true,
        },
        769: {
          spaceBetween: 30,
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
        1025: {
          spaceBetween: 40,
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
      },
    });
  }

  function initAnimations() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    document.querySelectorAll('.sensory-immersion').forEach(function (section) {
      if (section.dataset.siAnimReady) return;
      section.dataset.siAnimReady = '1';

      const heading = section.querySelector('.sensory-immersion__heading');
      const subtitle = section.querySelector('.sensory-immersion__subtitle');
      const media = section.querySelector('.sensory-immersion__media');
      const bodyText = section.querySelector('.sensory-immersion__body');
      const sensesText = section.querySelector('.sensory-immersion__senses');
      const rediscover = section.querySelector('.sensory-immersion__rediscover');

      if (!window.IntersectionObserver) {
        if (heading) heading.classList.add('is-visible');
        if (subtitle) subtitle.classList.add('is-visible');
        if (media) media.classList.add('is-visible');
        if (bodyText) bodyText.classList.add('is-visible');
        if (sensesText) sensesText.classList.add('is-visible');
        if (rediscover) rediscover.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: "0px",
        threshold: 0.15
      });

      if (heading) observer.observe(heading);
      if (subtitle) observer.observe(subtitle);
      if (media) observer.observe(media);
      if (bodyText) observer.observe(bodyText);
      if (sensesText) observer.observe(sensesText);
      if (rediscover) observer.observe(rediscover);
    });
  }

  function initCardFlips() {
    document.querySelectorAll('.sensory-immersion__slide-learn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const slide = btn.closest('.sensory-immersion__slide');
        if (slide) {
          slide.classList.add('is-flipped');
        }
      });
    });

    document.querySelectorAll('.sensory-immersion__slide-back').forEach(back => {
      back.addEventListener('click', () => {
        const slide = back.closest('.sensory-immersion__slide');
        if (slide) {
          slide.classList.remove('is-flipped');
        }
      });
      back.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const slide = back.closest('.sensory-immersion__slide');
          if (slide) {
            slide.classList.remove('is-flipped');
          }
        }
      });
    });
  }

  function initSiCtaSmoothScroll() {
    var ctas = document.querySelectorAll('.sensory-immersion__cta');
    if (!ctas.length) return;

    function getHeaderOffset() {
      var header = document.querySelector('#header-component, .header, header[role="banner"]');
      if (!header) return 0;
      var rect = header.getBoundingClientRect();
      var style = window.getComputedStyle(header);
      if (style.position === 'fixed' || style.position === 'sticky') {
        return rect.height;
      }
      return 0;
    }

    function targetTop(target) {
      return target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 16;
    }

    function correctIfDrifted(target, attempts) {
      attempts = attempts || 0;
      if (attempts > 4) return;

      var desired = targetTop(target);
      var current = window.pageYOffset;

      if (Math.abs(desired - current) > 2) {
        window.scrollTo({ top: desired, behavior: 'smooth' });
        setTimeout(function () { correctIfDrifted(target, attempts + 1); }, 350);
      }
    }

    function waitForScrollEnd(cb) {
      var lastY = window.pageYOffset;
      var stable = 0;
      var ticks = 0;

      function tick() {
        ticks++;
        var y = window.pageYOffset;
        if (Math.abs(y - lastY) < 0.5) {
          stable++;
          if (stable >= 4) return cb();
        } else {
          stable = 0;
        }
        lastY = y;
        if (ticks > 180) return cb();
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    ctas.forEach(function (cta) {
      if (cta.dataset.siSmoothScrollReady) return;
      cta.dataset.siSmoothScrollReady = '1';

      var href = cta.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;

      cta.addEventListener('click', function (e) {
        var id = href.slice(1);
        var target = document.getElementById(id);
        if (!target) return;

        e.preventDefault();

        if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) {
          ScrollTrigger.refresh();
        }

        window.scrollTo({ top: targetTop(target), behavior: 'smooth' });

        if (history.pushState) {
          history.pushState(null, '', href);
        }

        waitForScrollEnd(function () {
          if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) {
            ScrollTrigger.refresh();
          }
          correctIfDrifted(target);
        });
      });
    });
  }

  function initAllSwipers() {
    var SwiperConstructor = getSwiperConstructor();
    if (!SwiperConstructor) return false;

    initMediaSwiper(SwiperConstructor);
    initSensesSwiper(SwiperConstructor);
    initAnimations();
    initCardFlips();
    initSiCtaSmoothScroll();
    return true;
  }

  function initWithRetry(retriesLeft) {
    if (retriesLeft <= 0) {
      console.warn('[sensory-immersion] Swiper not found after retries.');
      return;
    }

    var success = initAllSwipers();
    if (!success) {
      setTimeout(function () {
        initWithRetry(retriesLeft - 1);
      }, INITIALIZATION_INTERVAL_MS);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithRetry(INITIALIZATION_RETRIES);
    });
  } else {
    initWithRetry(INITIALIZATION_RETRIES);
  }
})();
